"use client";
import { useLang } from "@/providers/langProvider";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { usePathname } from "next/navigation";

const SvgBarSearch = () => {
  const pathname = usePathname();
  const lang = useLang();

  const selected = pathname === `/${lang}${PagesPaths.search}`;
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.10417 0.25C3.77926 0.25 0.25 3.77926 0.25 8.10417C0.25 12.4291 3.77926 15.9583 8.10417 15.9583C9.87713 15.9583 11.5107 15.3587 12.8279 14.3608L17.9007 19.4326C18.0005 19.5366 18.1201 19.6196 18.2524 19.6768C18.3847 19.734 18.5271 19.7642 18.6712 19.7656C18.8154 19.7671 18.9583 19.7398 19.0918 19.6853C19.2252 19.6308 19.3464 19.5503 19.4484 19.4484C19.5503 19.3464 19.6308 19.2252 19.6853 19.0918C19.7398 18.9583 19.7671 18.8154 19.7656 18.6712C19.7642 18.5271 19.734 18.3847 19.6768 18.2524C19.6196 18.1201 19.5366 18.0005 19.4326 17.9007L14.3608 12.8279C15.3587 11.5107 15.9583 9.87713 15.9583 8.10417C15.9583 3.77926 12.4291 0.25 8.10417 0.25ZM8.10417 2.41667C11.2581 2.41667 13.7917 4.95021 13.7917 8.10417C13.7917 9.61851 13.2035 10.9862 12.2471 12.0027C12.154 12.0701 12.0722 12.1519 12.0048 12.245C10.9881 13.2026 9.61959 13.7917 8.10417 13.7917C4.95021 13.7917 2.41667 11.2581 2.41667 8.10417C2.41667 4.95021 4.95021 2.41667 8.10417 2.41667Z"
        className={`${selected ? "fill-secondary" : "fill-gray3"}`}
      />
    </svg>
  );
};

export default SvgBarSearch;
